import MuiSlider, { type SliderProps } from "@mui/material/Slider";

export type { SliderProps };

export function Slider(props: SliderProps) {
  return <MuiSlider {...props} />;
}
